import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { HelpCircle, AlertTriangle } from "lucide-react";

const TaxFAQ = () => {
  return (
    <div className="min-h-screen bg-background text-foreground py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <HelpCircle className="h-8 w-8 text-primary" />
            <h1 className="font-poppins font-bold text-4xl md:text-5xl text-foreground">Help Center</h1>
          </div>
          <p className="font-inter text-xl text-muted-foreground">
            Frequently Asked Questions
          </p>
        </div>

        <div className="space-y-8">
          <Card>
            <CardHeader>
              <CardTitle className="font-poppins text-2xl text-foreground">Do I need to pay taxes on AnySkill?</CardTitle>
            </CardHeader>
            <CardContent className="space-y-6">
              <div>
                <h4 className="font-poppins font-semibold mb-3 text-foreground">Your Tax Responsibility</h4>
                <p className="font-inter text-foreground mb-4">
                  Yes, you are responsible for any income you earn through AnySkill. AnySkill is a peer-to-peer platform 
                  that connects users directly - we don't act as an employer and don't withhold or report taxes for you.
                </p>
                <p className="font-inter text-foreground">
                  This means that any money you make providing services on our platform is considered income that you 
                  may need to report to the IRS or your local government.
                </p>
              </div>

              <div>
                <h4 className="font-poppins font-semibold mb-3 text-foreground">Small Amounts and Record Keeping</h4>
                <p className="font-inter text-foreground mb-4">
                  Most small amounts may not require filing, but tax laws vary and change. It's important to keep track 
                  of all income you earn, no matter how small, so you can make informed decisions about your tax obligations.
                </p>
                <p className="font-inter text-foreground">
                  We recommend keeping records of:
                </p>
                <ul className="font-inter text-foreground space-y-1 ml-6 mt-2">
                  <li>• All payments received through AnySkill</li>
                  <li>• Services provided and dates</li>
                  <li>• Any expenses related to providing services</li>
                </ul>
              </div>

              <div>
                <h4 className="font-poppins font-semibold mb-3 text-foreground">If You're Under 18</h4>
                <p className="font-inter text-foreground">
                  If you're under 18, you should ask a parent or guardian for help understanding your tax responsibilities. 
                  They can help you determine what income needs to be reported and assist you with any necessary paperwork.
                </p>
              </div>

              <div className="bg-amber-50 dark:bg-amber-900/20 p-4 rounded-lg border border-amber-200 dark:border-amber-800">
                <div className="flex items-start space-x-3">
                  <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400 mt-0.5 flex-shrink-0" />
                  <div>
                    <h4 className="font-poppins font-semibold text-amber-800 dark:text-amber-200 mb-2">Important Disclaimer</h4>
                    <p className="font-inter text-amber-700 dark:text-amber-300 text-sm">
                      AnySkill does not provide tax advice. Tax laws are complex and vary by location and individual circumstances. 
                      Please consult a qualified tax professional or advisor in your jurisdiction if you have specific questions 
                      about your tax obligations.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="font-poppins font-semibold mb-3 text-foreground">Additional Resources</h4>
                <p className="font-inter text-foreground">
                  For more information about tax obligations in the United States, you can visit the IRS website at 
                  irs.gov or consult with a tax professional. If you're in another country, check with your local 
                  tax authority for guidance.
                </p>
              </div>
            </CardContent>
          </Card>

          <div className="bg-muted p-6 rounded-lg text-center">
            <p className="font-inter text-foreground mb-2">
              Have other questions? We're here to help!
            </p>
            <p className="font-inter text-sm text-muted-foreground">
              Contact our support team through the feedback system for general platform questions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxFAQ;